/** Layout tokens for MultiplexListingNavCard. */

/** Outer `role="button"` layer (click + Enter/Space); pending state dims and blocks pointer events. */
export const navCardTriggerCss = (isNavigationPending: boolean) => ({
  all: 'unset' as const,
  display: 'block' as const,
  width: '100%',
  cursor: isNavigationPending ? ('wait' as const) : ('pointer' as const),
  opacity: isNavigationPending ? 0.6 : 1,
  pointerEvents: isNavigationPending ? ('none' as const) : ('auto' as const),
});

export const navCardPanelCss = {
  display: 'flex' as const,
  flexDirection: 'row' as const,
  alignItems: 'center' as const,
  justifyContent: 'space-between' as const,
  gap: '200',
  width: '100%',
  paddingBlock: '300',
  paddingInline: '400',
  textAlign: 'left' as const,
};

/** Leading icon + title/subtitle (sibling to trailing chevron inside the card row). */
export const navCardLeadingRowCss = {
  display: 'flex' as const,
  flexDirection: 'row' as const,
  alignItems: 'center' as const,
  gap: '300',
  minWidth: 0,
  flex: 1,
};

export const navCardTextColumnCss = {
  display: 'flex' as const,
  flexDirection: 'column' as const,
  gap: '25',
  minWidth: 0,
};
